import api from '@pray/shared/utils/api';

export const CAMPAIGN_NOTE_TOPICS = [
  'comp',
  'reopen',
  'backdated',
  'parity',
  'fee',
  'pacing',
  'pause',
  'general',
] as const;

export type CampaignNoteTopic = (typeof CAMPAIGN_NOTE_TOPICS)[number];

export const CAMPAIGN_NOTE_MAX_LENGTH = 2000;

export type CreateMarketingCampaignNoteParams = {
  artistId: string;
  campaignId: string;
  message: string;
  topic?: CampaignNoteTopic;
  /** Id of the entry this note corrects. Must belong to the same campaign. */
  supersedes?: string;
};

export const createMarketingCampaignNote = async ({
  artistId,
  campaignId,
  message,
  topic,
  supersedes,
}: CreateMarketingCampaignNoteParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/notes`;

  const body: Record<string, unknown> = { message };
  if (topic) body.topic = topic;
  if (supersedes) body.supersedes = supersedes;

  const response = await api.executePostRequest(url, body);

  return response.data;
};
